import View, { store } from '.';
import render from '../../render';
render(View, store, 'travel_collection');
